
import { mapState, mapGetters, mapActions } from 'vuex';
import { trimParams } from '@/lib/params';
import LandingPageSectionType from '@/enums/LandingPageSectionType';
import LandingPageCouponsSection from '@/components/crm/LandingPageCouponsSection';
import LandingPageProductRecommendationsSection from '@/components/crm/LandingPageProductRecommendationsSection';
import LandingPageCartsSection from '@/components/crm/LandingPageCartsSection';
import LandingPageUnpaidOrdersSection from '@/components/crm/LandingPageUnpaidOrdersSection';

const SECTION_COMPONENTS = {
  [LandingPageSectionType.COUPONS]: LandingPageCouponsSection,
  [LandingPageSectionType.PRODUCT_RECOMMENDATIONS]: LandingPageProductRecommendationsSection,
  [LandingPageSectionType.CARTS]: LandingPageCartsSection,
  [LandingPageSectionType.UNPAID_ORDERS]: LandingPageUnpaidOrdersSection
};

export default {
  name: 'LandingPage',
  data: () => ({ isLoading: true }),
  computed: {
    ...mapState('crmLandingPage', ['design']),
    ...mapGetters('crmLandingPage', [
      'title',
      'description',
      'couponTitle',
      'recommendationTitle',
      'cartTitle',
      'unpaidOrderTitle',
      'sectionTypes'
    ])
  },
  created() {
    const { brand_code } = this.$route.params;
    const { crm_campaign_id, crm_cohort_item_id, link_id } = this.$route.query;
    this.fetchLandingPage({
      brandCode: brand_code,
      sessionParams: trimParams({
        crm_campaign_id,
        crm_cohort_item_id,
        link_id
      })
    }).finally(() => (this.isLoading = false));
  },
  methods: {
    ...mapActions('crmLandingPage', ['fetchLandingPage']),
    sectionTitle(sectionType) {
      switch (sectionType) {
        case LandingPageSectionType.COUPONS:
          return this.couponTitle;
        case LandingPageSectionType.PRODUCT_RECOMMENDATIONS:
          return this.recommendationTitle;
        case LandingPageSectionType.CARTS:
          return this.cartTitle;
        case LandingPageSectionType.UNPAID_ORDERS:
          return this.unpaidOrderTitle;
        default:
          return '';
      }
    },
    sectionComponent(sectionType) {
      return SECTION_COMPONENTS[sectionType];
    }
  }
};
